<template>
  <div>
    <div v-for="(item,index) in markerList" :key="'sceneViewMarker'+item.viewId">
      <scene-view-marker :markerInfo="item" :markerIndex="index" @clickMarker="clickMarker"></scene-view-marker>
    </div>
  </div>
</template>

<script>
import SceneViewMarker from "@/views/globe/globe_marker/SceneViewMarker";

export default {
  name: "SceneViewMarkerEntry",
  components: {SceneViewMarker},
  props:['markerList'],
  methods:{
    clickMarker(markerInfo){
      this.$emit("clickMarker",markerInfo)
    }
  }

}
</script>

<style scoped>

</style>